<div
  class="d-flex align-items-center justify-content-center"
  style="height: 100vh"
>
  <app-loading></app-loading>
</div>
